import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
var __default__ = {
  head: {
    title: function title() {
      return {
        inner: "QR Code"
      };
    },
    meta: []
  }
};
import { ref, computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useStore } from "vue2-helpers/vuex";
import moment from "moment";
import { getDataByPostMethod } from "@/services/axios";
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'QrGen',
  setup: function setup(__props) {
    var _route$params;

    var route = useRoute();
    var store = useStore();
    var school = computed(function () {
      return store.state.school;
    });
    var isLoading = ref(true);
    var isShowNotice = ref(false);
    var isShowError = ref(false);
    var qrUrlList = ref([]);

    var createQrData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getDataByPostMethod("writer/write_participant_qrcode", {
                  belonging: route.params.belong,
                  participant_count: route.params.number
                });

              case 3:
                data = _context.sent;
                // participantの時はqueryにpをつける
                qrUrlList.value = data.item.map(function (v) {
                  return {
                    url: process.env.VUE_APP_GUARDIAN_APP_URL + "/entry/" + v.id + "?p=1",
                    expire: v.expire_on
                  };
                });
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                isShowError.value = true;

              case 10:
                _context.prev = 10;
                isLoading.value = false;
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7, 10, 13]]);
      }));

      return function createQrData() {
        return _ref.apply(this, arguments);
      };
    }(); // created


    if (route !== null && route !== void 0 && (_route$params = route.params) !== null && _route$params !== void 0 && _route$params.number) {
      createQrData();
    } else {
      isLoading.value = false;
      isShowNotice.value = true;
    }

    return {
      __sfc: true,
      route: route,
      store: store,
      school: school,
      isLoading: isLoading,
      isShowNotice: isShowNotice,
      isShowError: isShowError,
      qrUrlList: qrUrlList,
      createQrData: createQrData,
      moment: moment
    };
  }
});